/* Japanese storefront copy settings. Values are text; HTML, URLs and amounts are never evaluated. */
(function () {
  'use strict';
  if (window.TEGSUMI_EDITABLE_COPY) return;
  const norm = v => String(v == null ? '' : v).replace(/\s+/g, ' ').trim();
  const skip = 'script,style,noscript,textarea,input,pre,code,svg,.price,.cat-price,.cart-unit,.line-total,.cart-count,[data-cart-count],.qty,.pdp-sticky-price,.shopify-policy__container,.shopify-block';
  const money = /^(?:[¥￥]|JP¥|JPY\b|USD\b|CAD\b|AUD\b|THB\b|MYR\b)/;
  const records = new Map(), assignments = new Map(), originals = new WeakMap(), originalAttributes = new WeakMap();
  let observer, scheduled = false, activeScope = '', lastBound = 0, unmatched = [];
  const shop = () => window.TEGSUMI_SHOP || {};
  const japanese = () => ((window.TEGSUMI && TEGSUMI.lang()) || shop().locale || 'ja').split('-')[0] === 'ja';
  const designMode = () => !!(window.Shopify && Shopify.designMode);
  function pathOnly(value) {
    try {
      let p = new URL(value, location.origin).pathname;
      const root = (shop().routes && shop().routes.root || '/').replace(/\/$/, '');
      if (root && (p === root || p.startsWith(root + '/'))) p = p.slice(root.length) || '/';
      return p.replace(/\/$/, '') || '/';
    } catch (_) { return ''; }
  }
  function productScope(handle) {
    const aliases = window.TEGSUMI_HANDLES || {};
    return 'product:' + (Object.keys(aliases).find(k => aliases[k] === handle) || handle);
  }
  function pageScope() {
    const query = new URLSearchParams(location.search);
    if (['guide', 'stores', 'magazine'].includes(query.get('view'))) return query.get('view');
    if (window.TEGSUMI_PRODUCT && TEGSUMI_PRODUCT.handle) return productScope(TEGSUMI_PRODUCT.handle);
    const p = pathOnly(location.href);
    if (p === '/') return 'home';
    for (const k of ['guide', 'story', 'stores', 'magazine']) if (shop().links && shop().links[k] && p === pathOnly(shop().links[k])) return k;
    if (/^\/(collections|search)(\/|$)/.test(p)) return 'catalog';
    return 'info';
  }
  function readRecords() {
    records.clear();
    document.querySelectorAll('[data-tegsumi-copy-section]').forEach(script => {
      try {
        const data = JSON.parse(script.textContent);
        (data.fields || []).forEach(f => {
          if (f && typeof f.source === 'string') records.set(f.key, { ...f, scope: data.scope });
        });
      } catch (e) { console.warn('TEGSUMI: 文案設定を読み込めません。元の文章を表示します。', e); }
    });
  }
  function sourceOf(node) {
    const state = originals.get(node);
    if (state && node.nodeValue === state.applied) return state.original;
    return node.nodeValue;
  }
  function textChildren(parent) {
    return [...parent.childNodes].flatMap(n => n.nodeType === 3 ? [n] :
      n.nodeType === 1 && n.hasAttribute('data-tegsumi-copy-inline') ? [...n.childNodes].filter(c => c.nodeType === 3) : []);
  }
  function attributeSource(el,attr){const state=originalAttributes.get(el)?.get(attr);return state&&el.getAttribute(attr)===state.applied?state.original:el.getAttribute(attr);}
  function safeElement(el) { return el && !el.closest(skip); }
  function exactTarget(f) {
    if (!f.selector) return null;
    let parent;
    try { parent = document.querySelector(f.selector); } catch (_) { return null; }
    if (!parent) return null;
    if (f.attribute) {
      if (parent.closest('script,style,svg,.shopify-block')) return null;
      return norm(parent.getAttribute(f.attribute)) === norm(f.source) ? { element: parent, attribute: f.attribute, original: parent.getAttribute(f.attribute) } : null;
    }
    if (!safeElement(parent)) return null;
    const node = textChildren(parent)[f.textIndex];
    return node && norm(sourceOf(node)) === norm(f.source) ? { node, element: parent, original: sourceOf(node) } : null;
  }
  function editorAttribute(f) {
    if (!f.editorAttributes) return null;
    const t = document.createElement('template');
    // This string comes only from Liquid block.shopify_attributes, never from an edited text value.
    t.innerHTML = '<span ' + f.editorAttributes + '></span>';
    return t.content.firstElementChild.getAttribute('data-shopify-editor-block');
  }
  function bindInspector(f, a) {
    if (!designMode() || !japanese()) return;
    const attribute = editorAttribute(f);
    if (!attribute) return;
    let el = a.element;
    if (a.node) {
      if (a.node.parentElement.hasAttribute('data-tegsumi-copy-inline')) el = a.node.parentElement;
      else {
        el = document.createElement('span');
        el.setAttribute('data-tegsumi-copy-inline', f.key);
        a.node.parentNode.insertBefore(el, a.node); el.appendChild(a.node);
      }
    }
    // Existing native navigation or application blocks retain their original inspector ownership.
    if (el.hasAttribute('data-shopify-editor-block') && !el.hasAttribute('data-tegsumi-copy-owner')) return;
    el.setAttribute('data-shopify-editor-block', attribute);
    el.setAttribute('data-tegsumi-copy-owner', f.key);
    a.inspector = el;
  }
  function templateValue(f, source) {
    const escaped = norm(f.source).split('{n}').map(s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    if (escaped.length !== 2) return null;
    const match = norm(source).match(new RegExp('^' + escaped[0] + '(\\d+)' + escaped[1] + '$'));
    return match ? String(f.value == null ? f.source : f.value).replaceAll('{n}', match[1]) : null;
  }
  function apply() {
    scheduled = false;
    if (!document.body) return;
    if (observer) observer.disconnect();
    activeScope = pageScope();
    const enabled = japanese(), local = [...records.values()].filter(f => f.scope === activeScope);
    const common = [...records.values()].filter(f => f.scope === 'common');
    const used = new Set(), owned = new Set();
    for (const [key,a] of assignments) {
      if (!(a.node || a.element).isConnected) { assignments.delete(key); continue; }
      const f = records.get(key);
      if (!f || (f.scope !== activeScope && f.scope !== 'common' && !f.scope.startsWith('product:'))) {
        if (a.node && a.node.nodeValue === a.applied) a.node.nodeValue = a.original;
        else if (a.attribute && a.element.getAttribute(a.attribute) === a.applied) a.element.setAttribute(a.attribute,a.original);
        if (a.inspector) { a.inspector.removeAttribute('data-shopify-editor-block');a.inspector.removeAttribute('data-tegsumi-copy-owner'); }
        assignments.delete(key);continue;
      }
      used.add(key); if (a.node) owned.add(a.node);
    }
    // Resolve selectors before inserting inspector spans, so source child indexes stay consistent.
    for (const f of local) {
      if (used.has(f.key)) continue;
      const target = exactTarget(f);
      if (target && (!target.node || !owned.has(target.node))) {
        assignments.set(f.key,target);used.add(f.key);if(target.node)owned.add(target.node);
      }
    }
    const bySource = new Map();
    for (const f of [...local, ...common]) if (!f.attribute && (!used.has(f.key) || f.scope === 'common')) {
      const s = norm(f.source); if (!bySource.has(s)) bySource.set(s,[]); bySource.get(s).push(f);
    }
    const tree = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);const pending=[];let node;
    unmatched=[];
    while ((node = tree.nextNode())) {
      if (owned.has(node) || !safeElement(node.parentElement)) continue;
      const source = sourceOf(node), s = norm(source);
      if (!s || money.test(s)) continue;
      const options = bySource.get(s) || [];
      let f = options.find(x => !used.has(x.key));
      // A shared label can occur repeatedly; it remains one common setting, with one inspector owner.
      if (!f) f = options.find(x => x.scope === 'common');
      if (!f) {
        const named=node.parentElement.closest('[data-product-name]');
        const card=node.parentElement.closest('.cat-card,.product-card,.cart-line');
        const link=card&&card.querySelector('a[href*="/products/"]');
        const handle=named?decodeURIComponent(named.getAttribute('data-product-name')):link?decodeURIComponent(new URL(link.href,location.origin).pathname.split('/').pop()):'';
        if(handle)f=[...records.values()].find(x=>x.scope===productScope(handle)&&!x.attribute&&norm(x.source)===s);
      }
      if (!f) {
        const template = common.find(x => x.source.includes('{n}') && templateValue(x,source) !== null);
        if (template) pending.push({f:template,a:{node,element:node.parentElement,original:source},shared:true,template:true});
        else if(/[A-Za-z\u3040-\u30ff\u3400-\u9fff]/.test(s))unmatched.push({source:s,tag:node.parentElement.tagName,className:node.parentElement.className,link:node.parentElement.closest('a')?.getAttribute('href')||'',nativeContent:!!node.parentElement.closest('.news-row,.news-body,.rte,.shopify-policy__container'),inMain:!!node.parentElement.closest('main')});
        continue;
      }
      const a={node,element:node.parentElement,original:source};
      if (used.has(f.key)) pending.push({f,a,shared:true});
      else {assignments.set(f.key,a);used.add(f.key);owned.add(node);}
    }
    // Placeholder, accessibility and image-description fields are editable without modifying form values.
    for (const el of document.querySelectorAll('[placeholder],[aria-label],[title],img[alt]')) {
      if (el.closest('script,style,svg,.shopify-block')) continue;
      for (const attr of ['placeholder','aria-label','title','alt']) {
        const value=attributeSource(el,attr);if(!value)continue;
        if([...assignments.values()].some(a=>a.element===el&&a.attribute===attr))continue;
        const f=common.find(f=>f.attribute===attr&&norm(f.source)===norm(value));
        if(f&&!used.has(f.key)){assignments.set(f.key,{element:el,attribute:attr,original:value});used.add(f.key);}
        else if(f)pending.push({f,a:{element:el,attribute:attr,original:value},shared:true});
      }
    }
    function setValue(f,a,shared=false,isTemplate=false) {
      const raw=f.value==null?f.source:String(f.value);
      const value=enabled?(isTemplate?templateValue(f,a.original):raw):a.original;
      if (a.node) {
        const current=a.node.nodeValue;
        if(a.applied!==undefined&&current!==a.applied&&norm(current)!==norm(a.original)) {
          // A renderer changed this node: rebind it on the next pass rather than replacing unrelated text.
          originals.delete(a.node);assignments.delete(f.key);return;
        }
        const next=enabled?(a.original.match(/^\s*/)[0]+value+a.original.match(/\s*$/)[0]):a.original;
        if(current!==next)a.node.nodeValue=next;
        a.applied=next;originals.set(a.node,{original:a.original,applied:next});
      } else if(a.attribute) {
        if(a.element.getAttribute(a.attribute)!==value)a.element.setAttribute(a.attribute,value);
        a.applied=value;
        if(!originalAttributes.has(a.element))originalAttributes.set(a.element,new Map());
        originalAttributes.get(a.element).set(a.attribute,{original:a.original,applied:value});
      }
      if(!shared)bindInspector(f,a);
    }
    for(const [key,a]of assignments){const f=records.get(key);if(f)setValue(f,a);}
    for(const p of pending)setValue(p.f,p.a,p.shared,p.template);
    lastBound=assignments.size;
    if(observer)observer.observe(document.body,{childList:true,characterData:true,subtree:true});
  }
  function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(apply);}}
  function refresh(){readRecords();schedule();}
  function start(){
    observer=new MutationObserver(changes=>{
      if(changes.some(r=>[...r.addedNodes,...r.removedNodes].some(n=>n.nodeType===1&&(n.matches('[data-tegsumi-copy-section]')||n.querySelector('[data-tegsumi-copy-section]')))))readRecords();
      schedule();
    });
    refresh();
  }
  document.addEventListener('shopify:section:load',refresh);
  document.addEventListener('shopify:section:unload',()=>setTimeout(refresh,0));
  document.addEventListener('shopify:section:reorder',refresh);
  document.addEventListener('shopify:block:select',event=>{
    const f=[...records.values()].find(f=>f.blockId===event.detail.blockId);const a=f&&assignments.get(f.key);
    if(a)(a.inspector||a.element).scrollIntoView({behavior:'smooth',block:'center'});
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  function savedText(source,attribute='') {
    if(!japanese())return source;
    const scope=pageScope();
    const candidates=[...records.values()].filter(f=>f.attribute===attribute&&norm(f.source)===norm(source));
    const f=candidates.find(f=>f.scope==='common')||candidates.find(f=>f.scope===scope);
    return f&&f.value!=null?String(f.value):source;
  }
  window.TEGSUMI_EDITABLE_COPY={refresh,text:savedText,version:'20261104',coverage:()=>({scope:activeScope,fields:records.size,bound:lastBound,unmatched:[...unmatched]})};
})();
